import { Component, OnInit, Renderer2 } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { NotificationTextMessage } from '@app/core/Enum';
import { GlobalComponent } from '@app/core/Models';
import { CommonService } from '@app/core/Services';
import { GetAllContactsBasedonType, GetAllDislcosuresListBasedonType, MenuState, ToggleCheck } from '@app/core/Store';
import { GetAllAuditDetails, GetAudit, GetAuditBasedonId, GetAuditReportDetailsByType, SaveAuditDetails, SaveAuditReportDetails } from '@app/core/Store/report/audit-report/audit-report.action';
import { AddAuditPopupComponent, AddClosePopupComponent } from '@app/modules/common';
import { EditAuditReportPopupComponent } from '@app/modules/common';
import { Select, Store } from '@ngxs/store';
import { NgxSpinnerService } from 'ngx-spinner';
import { Observable } from 'rxjs';

@Component({
  selector: 'app-audit-report',
  templateUrl: './audit-report.component.html',
  styleUrls: ['./audit-report.component.scss']
})
export class AuditReportComponent implements OnInit {
  auditList: any;
  auditDetailForm: FormGroup;
  savePayload: any = {};
  renderer: Renderer2;
  accountingBodies: any[] = ["ACCA","ICAEW","ICAS","CIMA","AAT","AIA","IFA"];
  selectedId?: any;
  selectedAudit: any;
  selectedReportId: any;
  reports: any[];
  reportDetails: any;
  @Select(MenuState.getSelectedMenuPermission)
  isViewPermission$: Observable<any>;
  commonNotificationText = NotificationTextMessage;

  periodicDate: any;
  minInvoiceDate: Date;
  maxInvoiceDate: Date = new Date();

  constructor(
    private store: Store, 
    public dialog: MatDialog, 
    private spinner: NgxSpinnerService, 
    private commonService: CommonService,
    private globalComponent: GlobalComponent,
  ) {}

  ngOnInit(): void {
    this.periodicDate = this.globalComponent.getFinancialPeriod();
    this.getContactDetails();
    this.setForm();
    this.getAllAudits();
    this.setInvoiceDateLimits();
  }

  setForm(): void{
    this.auditDetailForm = new FormGroup({
      name: new FormControl('', [Validators.required, this.commonService.whiteSpaceValidate]),
      lastName: new FormControl('', [Validators.required, this.commonService.whiteSpaceValidate]),
      country: new FormControl(''),
      county: new FormControl(''),
      address1: new FormControl(''),
      address2: new FormControl(''),
      city: new FormControl(''),
      postCode: new FormControl(''),
      firmName:new FormControl(''),
      accountingbody:new FormControl(''),
      selectedAccountingBody: new FormControl(''),
      dateAudited: new FormControl(''),
      rfirmname:new FormControl(''),
      firmLocation:new FormControl(''),
    });
  }

  getAudit(): void{
    this.store.dispatch(new GetAudit()).pipe().subscribe(
      (response: any) => {
        const res = response.AuditReport.auditDetails;
        this.selectedId = res?.id;
        this.auditDetailForm.patchValue({
          name: res.name + ' ' + res?.lastName,
          lastName: res.lastName,
          country: res.country,
          county: res.county,
          address1: res.address1,
          address2: res.address2,
          city: res.city,
          postCode: res.postCode,
          firmName: res.firmName,
          dateAudited: res.dateAudited ? new Date(res.dateAudited) : null,
          rfirmname: res.rfirmname,
          firmLocation: res.firmLocation,
        });
        if(this.accountingBodies.includes(res.accountingbody)){
          this.auditDetailForm.controls.selectedAccountingBody.setValue(res.accountingbody);
        } else {
          this.auditDetailForm.controls.selectedAccountingBody.setValue('0');
          this.auditDetailForm.controls.accountingbody.setValue(res.accountingbody);
        }
        this.disableField();
        this.getAllDislcosuresListBasedonType();
      }
    );
  }

  getAllDislcosuresListBasedonType(): void{
    this.store.dispatch(new GetAllDislcosuresListBasedonType('audit',this.isAudicted)).pipe().subscribe(
      (response: any) => {
        this.reports = response?.common?.reports;
      }
    );
  }

  disableField(): void{
    if(this.auditDetailForm.controls['selectedAccountingBody'].value === '0'){
      this.auditDetailForm.controls['accountingbody'].enable();
    } else {
      this.auditDetailForm.controls['accountingbody'].disable();
      this.auditDetailForm.controls.accountingbody.setValue('');
    }
  }

  getAllAudits(): void{
    this.store.dispatch(new GetAllAuditDetails()).pipe().subscribe(
      (response: any) => {
        this.auditList = response.AuditReport.audits;
        if(this.auditList) this.getAudit();
      }
    );
  }

  onAccountingBodyChange(event: any): void{
    this.disableField();
  }

  onAuditChange(event: any): void{
    this.selectedId = event;
    this.getDetailsbyId();
  }
  
  getDetailsbyId(): void{
    this.store.dispatch(new GetAuditBasedonId(this.selectedId)).pipe().subscribe(
      (response: any) => {
        const res = response.AuditReport.auditDetails;
        this.auditDetailForm.patchValue({
          name: res.name + ' ' + res?.lastName,
          lastName: res.lastName,
          country: res.country,
          county: res.county,
          address1: res.address1,
          address2: res.address2,
          city: res.city,
          dateAudited: res.dateAudited ? new Date(res.dateAudited) : null,
          postCode: res.postCode,
          firmName: res.firmName,
          rfirmname: res.rfirmname,
          firmLocation: res.firmLocation,
        });
        if(this.accountingBodies.includes(res.accountingbody)){
          this.auditDetailForm.controls.selectedAccountingBody.setValue(res.accountingbody);
        } else {
          this.auditDetailForm.controls.selectedAccountingBody.setValue('0');
          this.auditDetailForm.controls.accountingbody.setValue(res.accountingbody);
        }
        this.disableField();
        this.getAllDislcosuresListBasedonType();
      }
    );
  }

  onSave(action: string): any{
    this.spinner.show();
    try{
      let name = this.auditList.find((item:any)=>item?.id === this.selectedId)?.name;
      this.savePayload = {
        "id": action == 'edit' ? this.selectedId : '00000000-0000-0000-0000-000000000000',
        "name": name,
        "lastName": this.auditDetailForm.controls['lastName'].value,
        "address1": this.auditDetailForm.controls['address1'].value,
        "address2": this.auditDetailForm.controls['address2'].value,
        "city": this.auditDetailForm.controls['city'].value,
        "postCode": this.auditDetailForm.controls['postCode'].value,
        "country": this.auditDetailForm.controls['country'].value,
        "county": this.auditDetailForm.controls['county'].value,
        "isActive": true,
        "isDelete": true,
        "createdBy": '00000000-0000-0000-0000-000000000000',
        "updatedBy": '00000000-0000-0000-0000-000000000000',
        "updatedOn": null,
        "accountingbody": this.auditDetailForm.controls['selectedAccountingBody'].value === '0' ? this.auditDetailForm.controls['accountingbody'].value : this.auditDetailForm.controls['selectedAccountingBody'].value,
        "firmName": this.auditDetailForm.controls['firmName'].value,
        "dateAudited": this.getDateOnly(this.auditDetailForm.controls['dateAudited'].value),
        "rfirmname": this.auditDetailForm.controls['rfirmname'].value,
        "firmLocation": this.auditDetailForm.controls['firmLocation'].value,
        "ischeckedauditdetails": null,
        "isShowonreport": false
      }
    }catch (error) {
      this.spinner.hide();
      this.commonService.onFailure(NotificationTextMessage.errorMessage);
      return false;
    }
    return true;
  }

  saveDetails(action: string): void{
    if (this.auditDetailForm.invalid) {
      this.commonService.addValidation(this.auditDetailForm, this.renderer);
    } else if(this.onSave(action)){
      this.store.dispatch(new SaveAuditDetails(this.savePayload)).pipe().subscribe(
        (response: any) => {
          this.commonService.onSucess(NotificationTextMessage.successMessage);
          this.getAllAudits();
        }
      );
    }
  }

  addAuditDialog() {
    const dialogRef = this.dialog.open(AddAuditPopupComponent,{
      disableClose: true
    });

    dialogRef.componentInstance.accountingBodies = this.accountingBodies;
    dialogRef.afterClosed().subscribe(result => {
       if(result){
      this.getAllAudits();
       }
     });
  }

  editReport(title: any, content: any){
    const dialogRef = this.dialog.open(EditAuditReportPopupComponent);

    dialogRef.componentInstance.title = title;
    dialogRef.componentInstance.content = content;
    dialogRef.afterClosed().subscribe(result => {
      if(result){
        this.reportDetails.content = result?.content;
        this.saveReportDetails();
      }
    });
  }

  onCheckboxClick(event: any, report: any): void{
    const payload = {
      type: report.type,
      toggleFor: 'audit',
      IsCheck: event.checked   
    }
    this.store.dispatch(new ToggleCheck(payload)).pipe().subscribe(
      (response: any) => {
        this.getAllDislcosuresListBasedonType();
      }
    );
  }

  GetAuditReportDetailsByType(type): void{
    this.store.dispatch(new GetAuditReportDetailsByType(type)).pipe().subscribe(
      (response: any) => {
        this.reportDetails = response?.AuditReport?.reportDetails;
        this.editReport(this.reportDetails.title, this.reportDetails.content);
      }
    );
  }

  saveReportDetails(): void{
    this.store.dispatch(new SaveAuditReportDetails(this.reportDetails)).pipe().subscribe(
      (response: any) => {
        this.commonService.onSucess(NotificationTextMessage.successMessage);
        this.getAllDislcosuresListBasedonType();
      }
    );
  }
   iscompanyRegistered:boolean;
    isAudicted:boolean;
    getContactDetails(): void{
      this.store.dispatch(new GetAllContactsBasedonType(1)).pipe().subscribe(
        (response: any) => {
         
          this.iscompanyRegistered=response?.reportSettings?.iscompanyRegistered;
          this.isAudicted=response?.reportSettings?.isAudited;
          
        }
      );
    }

  onCloseClick(): void {
    this.dialog.open(AddClosePopupComponent, {});
  }

  setInvoiceDateLimits(): void {
    if (this.periodicDate?.length > 0) {
      const unlockedPeriod = this.periodicDate.find(
        (period: any) => !period.isLocked
      );

      if (unlockedPeriod) {
        this.minInvoiceDate = new Date(unlockedPeriod.fromDate);
      } else {
        this.minInvoiceDate = new Date(this.periodicDate[0].fromDate);
      }

      this.maxInvoiceDate = new Date(
        this.periodicDate[this.periodicDate.length - 1]?.toDate
      );
    }
  }

  private getDateOnly(date: any): string | null {
    if (!date) return null;
    const d = date instanceof Date ? date : new Date(date);
    const y = d.getFullYear();
    const m = ('0' + (d.getMonth() + 1)).slice(-2);
    const day = ('0' + d.getDate()).slice(-2);
    return `${y}-${m}-${day}`;
  }
}
